import React, { Component } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import { message, Button } from 'antd';

import { isLogin } from '../utils/index';
import { addtocart, addwishlist, removewishlist } from '../utils/byoscart';

import Loader from './utils/Loadersmall';
import ProductGallery from './utils/ProductGallery';

class Details extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu:[],
            productDetails:'',
            wishlistStatus:'',
            serviceCheck:false,
            quantity:1,
        }   
    }

    async componentDidMount() {
        this.loadProductDetails();
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            window.scrollTo(0, 0);
            this.setState({
                serviceCheck: false,
                quantity: 1,
            });
            this.loadProductDetails();
        }
    }

    async loadProductDetails() {

        /* scroll to top of the page */
        window.scrollTo(0, 0);


        const params = new URLSearchParams();
        params.append('variant_id', Buffer.from(this.props.match.params.id, 'base64').toString('ascii'));
        try {
            const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/productsDetails',params);
             let resVal=response.data;
              if(resVal.status==='success'){
                  this.setState({productDetails:resVal.data});
                  this.setState({serviceCheck:true, wishlistStatus:resVal.data.wishlist});
              }
              this.setState({serviceCheck:true});
          } catch (error) {
              this.setState({serviceCheck:true});
            console.error(error);
          }

         

        //   const script = document.createElement("script");
        //   script.async = true;
        //   script.src = "/assets/js/main.js";
        //   document.body.appendChild(script);

    }

    getVariantLabel(variant) {
        if (!variant || !variant.variant_code) {
            return variant && variant.variant_name ? variant.variant_name : 'Variant';
        }

        return variant.variant_code.variation_item1 || variant.variant_code.variation_item2 || variant.variant_name || 'Variant';
    }

    getVariantUrl(variant) {
        const variantId = variant && variant.variation_id ? variant.variation_id : '';
        const variantName = variant && variant.variant_name ? variant.variant_name : '';

        return `/details/${Buffer.from(String(variantId)).toString('base64')}/${encodeURIComponent(variantName)}`;
    }

    loadVariantOptions() {
        const variants = Array.isArray(this.state.productDetails.variants) ? this.state.productDetails.variants : [];

        if (variants.length === 0) {
            return null;
        }

        return (
            <div className="ps-product__variants">
                <h6>Size</h6>
                <div className="ps-product__variant-stock-row">
                    <div className="ps-product__variant-stack">
                        <div className="ps-product__variant-list">
                            {variants.map((variant) => {
                                const isActive = String(variant.variation_id) === String(this.state.productDetails.variation_id);

                                return (
                                    <Link
                                        key={variant.variation_id}
                                        to={this.getVariantUrl(variant)}
                                        className={`ps-product__variant ${isActive ? 'ps-product__variant--active' : ''}`}
                                        title={variant.variant_name}
                                    >
                                        {this.getVariantLabel(variant)}
                                    </Link>
                                );
                            })}
                        </div>
                    </div>

                    <div className="ps-product__stock">
                        <i className="fa fa-check" aria-hidden="true"></i>
                        <span>In stock</span>
                    </div>
                </div>
            </div>
        );
    }


    loginNotification(){
        message.error({
            content: 'Login to continue',
            className: 'notificationBox',
        });
    }

    localaddcart(){
        this.setState({cartStatus:'Yes'});
        addtocart(
            this.state.productDetails.product_id,
            this.state.productDetails.variation_id,
            this.state.quantity
        );
    }

    increaseQuantity(){
        this.setState((prevState) => ({
            quantity: prevState.quantity + 1,
        }));
    }

    decreaseQuantity(){
        this.setState((prevState) => ({
            quantity: prevState.quantity > 1 ? prevState.quantity - 1 : 1,
        }));
    }

    handleQuantityChange(event){
        const nextValue = parseInt(event.target.value, 10);

        this.setState({
            quantity: Number.isNaN(nextValue) || nextValue < 1 ? 1 : nextValue,
        });
    }

    localremovewishlist(){
        this.setState({wishlistStatus:'No'});
        removewishlist(this.state.productDetails.variation_id);
    }

    localaddwishlist(){
        this.setState({wishlistStatus:'Yes'});
        addwishlist(this.state.productDetails.variation_id);
    }

    loadWishlist(){
        if(this.state.wishlistStatus=='Yes'){
            return(
                <div className="ps-product__item wishlistActive detailPageButton" data-toggle="tooltip" data-placement="left" title="Wishlist"><a onClick={()=>this.localremovewishlist(this.state.productDetails.variation_id)}><i className="fa fa-heart-o"></i></a></div>
            )
        }else{
            return(
                <div className="ps-product__item detailPageButton" data-toggle="tooltip" data-placement="left" title="Wishlist"><a onClick={()=>this.localaddwishlist(this.state.productDetails.variation_id)}><i className="fa fa-heart-o"></i></a></div>
            )   
        }
    }

    loadImageSlider(){
        return(
            <>
                <ProductGallery galleryList={this.state.productDetails.display_image_all} {...this.props}/>
            </>
        )
    }


    render() {

        if(this.state.serviceCheck===false)
        return (<Loader/>);
        const { productDetails } = this.state;
        const ratingValue = 4.8;
        const reviewCount = 128;
        const productFeatures = [
            { icon: 'fa-leaf', label: '100% Natural' },
            { icon: 'fa-tint', label: 'Transfat Free' },
            { icon: 'fa-heart-o', label: 'Heart Healthy' },
            { icon: 'fa-flask', label: 'No Additives' },
        ];
        const detailHighlights = [
            { icon: 'fa-tint', title: 'Rich in', subtitle: 'Omega-6 & MUFA' },
            { icon: 'fa-heart-o', title: 'Helps Lower', subtitle: 'Cholesterol' },
            { icon: 'fa-leaf', title: 'Contains Natural', subtitle: 'Antioxidants' },
            { icon: 'fa-leaf', title: 'Traditionally', subtitle: 'Wood Pressed' },
            { icon: 'fa-flask', title: 'No Chemicals', subtitle: 'or Additives' },
        ];
        const serviceHighlights = [
            { icon: 'fa-truck', title: 'Free Delivery', subtitle: 'On orders above $50' },
            { icon: 'fa-shield', title: 'Secure Payment', subtitle: '100% secure checkout' },
            { icon: 'fa-refresh', title: 'Easy Returns', subtitle: '7 days return policy' },
        ];
        return (
            
                <div class="ps-page--product">
                        <div class="container whiteContainer">
                            <ul class="ps-breadcrumb">
                                <li class="ps-breadcrumb__item"><Link to="/">Home</Link></li>
                                <li class="ps-breadcrumb__item"><Link to="/">{productDetails.sub_category}</Link></li>
                                <li class="ps-breadcrumb__item"><Link to="/">{productDetails.final_category}</Link></li>
                                <li class="ps-breadcrumb__item active" aria-current="page">{productDetails.product_name}</li>
                            </ul>
                            <div class="ps-page__content">
                                <div class="ps-product--detail">
                                    <div class="row">
                                        <div class="col-12 col-md-12">
                                            <div class="row">
                                                <div class="col-12 col-xl-6">


                                                    {this.loadImageSlider()}


                                                </div>
                                                <div class="col-12 col-xl-6">
                                                        <div class="ps-product__info">
                                                            <div class="ps-product__branch">
                                                                <i className="fa fa-leaf" aria-hidden="true"></i>
                                                                <a>{productDetails.brand}</a>
                                                            </div>
                                                        <div class="ps-product__title"><a>{productDetails.product_name}</a></div>
                                                        <div class="ps-product__rating ps-product__rating--title" aria-label={`${ratingValue} out of 5 stars, ${reviewCount} reviews`}>
                                                            <span class="ps-product__rating-stars" aria-hidden="true">
                                                                <span class="rattingsStar"><i class="fa fa-star"></i></span>
                                                                <span class="rattingsStar"><i class="fa fa-star"></i></span>
                                                                <span class="rattingsStar"><i class="fa fa-star"></i></span>
                                                                <span class="rattingsStar"><i class="fa fa-star"></i></span>
                                                                <span class="rattingsStar"><i class="fa fa-star"></i></span>
                                                            </span>
                                                            <span class="ps-product__rating-score">{ratingValue}</span>
                                                            <span class="ps-product__review">({reviewCount} reviews)</span>
                                                        </div>
                                                        <div class="ps-product__features" aria-label="Product benefits">
                                                            {productFeatures.map((feature) => (
                                                                <div class="ps-product__feature" key={feature.label}>
                                                                    <i className={`fa ${feature.icon}`} aria-hidden="true"></i>
                                                                    <span>{feature.label}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div class="ps-product__purchase">
                                                            <div class="ps-product__meta">
                                                                <span class="ps-product__price">₹{productDetails.offer_price}</span>
                                                                <span class="ps-product__del">₹{productDetails.selling_price}</span>
                                                                <span className="ps-product__tax-note">Inclusive of all taxes</span>
                                                            </div>

                                                            {this.loadVariantOptions()}

                                                            <div className="ps-product__action-row">
                                                                <div className="ps-product__quantity ps-product__quantity--inline">
                                                                    <h6>Quantity</h6>
                                                                    <div className="def-number-input number-input safari_only">
                                                                        <button type="button" className="minus" onClick={()=>this.decreaseQuantity()}><i className="icon-minus"></i></button>
                                                                        <input className="quantity" min="1" name="quantity" value={this.state.quantity} type="number" onChange={(event)=>this.handleQuantityChange(event)} />
                                                                        <button type="button" className="plus" onClick={()=>this.increaseQuantity()}><i className="icon-plus"></i></button>
                                                                    </div>
                                                                </div>

                                                                <a className="ps-btn ps-btn--warning hand ps-product__action-cart" onClick={()=>isLogin()? this.localaddcart() : this.loginNotification()}>Add to cart</a>

                                                                <div className="ps-product__action-links">
                                                                    {this.loadWishlist()}
                                                                    <a className="ps-product__link hand">Add to Compare</a>
                                                                </div>
                                                            </div>

                                                            <div className="ps-product__service-row" aria-label="Delivery and payment benefits">
                                                                {serviceHighlights.map((item) => (
                                                                    <div className="ps-product__service-item" key={item.title}>
                                                                        <i className={`fa ps-product__service-icon ${item.icon}`} aria-hidden="true"></i>
                                                                        <div className="ps-product__service-copy">
                                                                            <strong>{item.title}</strong>
                                                                            <span>{item.subtitle}</span>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>

                                                           
                                                        </div>
                                                        {productDetails.highlights.length>0?
                                                        <div class="ps-product__desc">
                                                            <ul class="ps-product__list">
                                                            { productDetails.highlights.map((highlightsItem)=>{
                                                                return(
                                                                        <li>{highlightsItem.highlights}</li>
                                                                    )
                                                                })
                                                            }
                                                            </ul>
                                                        </div>
                                                        : null }
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="ps-product__highlight-strip" aria-label="Product highlights">
                                        {detailHighlights.map((item) => (
                                            <div className="ps-product__highlight-item" key={`${item.title}-${item.subtitle}`}>
                                                <i className={`fa ${item.icon}`} aria-hidden="true"></i>
                                                <div className="ps-product__highlight-copy">
                                                    <strong>{item.title}</strong>
                                                    <span>{item.subtitle}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div class="ps-product__content">
                                        <ul class="nav nav-tabs ps-tab-list" id="productContentTabs" role="tablist">
                                            <li class="nav-item" role="presentation"><a class="nav-link active" id="description-tab" data-toggle="tab" href="#description-content" role="tab" aria-controls="description-content" aria-selected="true">Description</a></li>
                                            <li class="nav-item" role="presentation"><a class="nav-link" id="specification-tab" data-toggle="tab" href="#specification-content" role="tab" aria-controls="specification-content" aria-selected="false">Specification</a></li>
                                            <li class="nav-item" role="presentation"><a class="nav-link" id="reviews-tab" data-toggle="tab" href="#reviews-content" role="tab" aria-controls="reviews-content" aria-selected="false">Reviews (0)</a></li>
                                        </ul>
                                        <div class="tab-content" id="productContent" >
                                            <div class="tab-pane fade show active" id="description-content" role="tabpanel" aria-labelledby="description-tab">
                                                <div class="ps-document mb-20">
                                                    
                                                    {/* <p class="ps-desc">{productDetails.short_description}</p> */}

                                                    <p class="ps-desc">{productDetails.long_description}</p>
                                                    
                                                </div>
                                            </div>
                                            <div class="tab-pane fade" id="specification-content" role="tabpanel" aria-labelledby="specification-tab">
                                                
                                                { productDetails.specification.map((specificationDetails)=>{
                                                    return(
                                                            <>
                                                            <div class="ps-table__name">{specificationDetails.specification_group_name}</div>

                                                            <table class="table ps-table ps-table--oriented">
                                                            <tbody>
                                                            { specificationDetails.specification_items.map((specificationItem)=>{
                                                                return(
                                                                    <tr>
                                                                        <th class="ps-table__th">{specificationItem.specificationitem_name}</th>
                                                                        <td>{specificationItem.specification}</td>
                                                                    </tr>
                                                                    )
                                                                })
                                                            }
                                                                </tbody>
                                                            </table>
                                                            </>
                                                        )
                                                    })
                                                }
                                                
                                            </div>
                                            <div class="tab-pane fade" id="reviews-content" role="tabpanel" aria-labelledby="reviews-tab">

                                                <div class="ps-document mb-20">
                                                    
                                                    <p class="ps-desc">No reviews found</p>
                                                    
                                                </div>

                                                {/* <div class="ps-product__tabreview">
                                                    <div class="ps-review--product">
                                                        <div class="ps-review__row">
                                                            <div class="ps-review__avatar"><img src="/assets/img/avatar/avatar-review.html" alt="alt" /></div>
                                                            <div class="ps-review__info">
                                                                <div class="ps-review__name">Mark J.</div>
                                                                <div class="ps-review__date">Oct 30, 2021</div>
                                                            </div>
                                                            <div class="ps-review__rating">
                                                                <select class="ps-rating" data-read-only="true">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4" selected="selected">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="ps-review__desc">
                                                                <p>Everything is perfect. I would recommend!</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="ps-review--product">
                                                        <div class="ps-review__row">
                                                            <div class="ps-review__avatar"><img src="/assets/img/avatar/avatar-review2.html" alt="alt" /></div>
                                                            <div class="ps-review__info">
                                                                <div class="ps-review__name">Ann R.</div>
                                                                <div class="ps-review__date">Oct 30, 2021</div>
                                                            </div>
                                                            <div class="ps-review__rating">
                                                                <select class="ps-rating" data-read-only="true">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4" selected="selected">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="ps-review__desc">
                                                                <p>There was a small mistake in the order. In return, I got the correct order and I could keep the wrong one for myself.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="ps-review--product">
                                                        <div class="ps-review__row">
                                                            <div class="ps-review__avatar"><img src="/assets/img/avatar/avatar-review3.html" alt="alt" /></div>
                                                            <div class="ps-review__info">
                                                                <div class="ps-review__name">Jenna S.</div>
                                                                <div class="ps-review__date">Oct 30, 2021</div>
                                                            </div>
                                                            <div class="ps-review__rating">
                                                                <select class="ps-rating" data-read-only="true">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4" selected="selected">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="ps-review__desc">
                                                                <p>I ordered on Friday evening and on Monday at 12:30 the package was with me. I have never encountered such a fast order processing.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="ps-review--product">
                                                        <div class="ps-review__row">
                                                            <div class="ps-review__avatar"><img src="/assets/img/avatar/avatar-review4.html" alt="alt" /></div>
                                                            <div class="ps-review__info">
                                                                <div class="ps-review__name">John M.</div>
                                                                <div class="ps-review__date">Oct 30, 2021</div>
                                                            </div>
                                                            <div class="ps-review__rating">
                                                                <select class="ps-rating" data-read-only="true">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4" selected="selected">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="ps-review__desc">
                                                                <p>Everything is perfect. I would recommend!</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="ps-review--product">
                                                        <div class="ps-review__row">
                                                            <div class="ps-review__avatar"><img src="/assets/img/avatar/avatar-review.html" alt="alt" /></div>
                                                            <div class="ps-review__info">
                                                                <div class="ps-review__name">Mark J.</div>
                                                                <div class="ps-review__date">Oct 30, 2021</div>
                                                            </div>
                                                            <div class="ps-review__rating">
                                                                <select class="ps-rating" data-read-only="true">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4" selected="selected">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="ps-review__desc">
                                                                <p>There was a small mistake in the order. In return I got the correct order and I could keep the wrong one for myself.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                {/* <div class="ps-form--review">
                                                    <div class="ps-form__title">Write a review</div>
                                                    <div class="ps-form__desc">Your email address will not be published. Required fields are marked *</div>
                                                    <form action="http://nouthemes.net/html/mymedi/do_action" method="post">
                                                        <div class="row">
                                                            <div class="col-12 col-lg-4">
                                                                <label class="ps-form__label">Your rating *</label>
                                                                <select class="ps-rating--form" data-value="0">
                                                                    <option value="1">1</option>
                                                                    <option value="2">2</option>
                                                                    <option value="3">3</option>
                                                                    <option value="4">4</option>
                                                                    <option value="5">5</option>
                                                                </select>
                                                            </div>
                                                            <div class="col-6 col-lg-4">
                                                                <label class="ps-form__label">Name *</label>
                                                                <input class="form-control ps-form__input"/>
                                                            </div>
                                                            <div class="col-6 col-lg-4">
                                                                <label class="ps-form__label">Email *</label>
                                                                <input class="form-control ps-form__input"/>
                                                            </div>
                                                            <div class="col-12">
                                                                <div class="ps-form__block">
                                                                    <label class="ps-form__label">Your review *</label>
                                                                    <textarea class="form-control ps-form__textarea"></textarea>
                                                                </div>
                                                            </div>
                                                            <div class="col-12 text-center">
                                                                <button class="btn ps-btn ps-btn--warning">Add Review</button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        );
    }
}

export default Details;
